import React, { useState, useEffect } from "react";
import GenericPopup from "@Components/Popup/Popup";
import NoteAddRoundedIcon from "@mui/icons-material/NoteAddRounded";
import { Box } from "@mui/system";
import SearchableDropDown from "@Components/DropDown/SearchableDropDown";
import { validateForm } from "@Utils/Validations/HelperFunctions/FormValidationFunctions";
import {
  Grid,
  Typography,
  Button,
  TextField,
  InputAdornment,
} from "@mui/material";
import {
  USERS_PLANNER_URL,
  LINK_PLANNER_WITH_EMAIL,
  GET_SPECIFIC_PLANNER,
} from "../../../API/APIRoutes";
import useGetAll from "@Hooks/useGetAll";
import useGetItem from "@Hooks/useGetItem";
import LockIcon from "@mui/icons-material/Lock";
import LoadingComponent from "@Components/LoadingComponent/LoadingComponent";
import useSendPutRequest from "../../../Hooks/useSendPutRequest";

export const LinkPlannerPopup = ({
  selectedPlannerId,
  showPopup,
  closePopup,
}) => {
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [plannerEmail, setPlannerEmail] = useState();
  const [userNameOptions, setuserNameOptions] = useState([]);
  const [isPopupLoading, setIsPopupLoading] = useState(true);

  const {
    requestMethod: updateData,
    isLoading: linkPlannerLoading,
    isError,
  } = useSendPutRequest(true);
  const getItem = useGetItem();
  const { getAll } = useGetAll();
  useEffect(() => {
    const fetchData = async () => {
      setIsPopupLoading(true);

      try {
        // Fetch all user planners
        const fetchedData = await getAll(
          USERS_PLANNER_URL,
          "Failed to fetch User Planners"
        );
        setuserNameOptions(
          fetchedData.map((item) => ({
            id: item.id,
            name: item.plannerEmail,
          }))
        );

        // If a planner is selected, fetch their info
        if (selectedPlannerId) {
          // to get Email that Linked With The planner
          const response = await getItem(
            GET_SPECIFIC_PLANNER,
            selectedPlannerId
          );
          setPlannerEmail(response.plannerEmail);
        } else {
          setPlannerEmail(null); // Clear planner email if not selected
        }
      } catch (error) {
        console.error("Error fetching planner data:", error);
      } finally {
        setIsPopupLoading(false); // Hide loader in all cases
      }
    };

    fetchData();
  }, [selectedPlannerId]);

  const content = isPopupLoading ? (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="150px" // Adjust height as needed
    >
      <LoadingComponent />
    </Box>
  ) : (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="body1" sx={{ mb: 1 }}>
          User Planner Email
        </Typography>
        {plannerEmail ? (
          <TextField
            variant="outlined"
            fullWidth
            name="plannerEmail"
            value={plannerEmail}
            disabled
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <LockIcon fontSize="small" sx={{ color: "gray" }} />
                </InputAdornment>
              ),
            }}
          />
        ) : (
          <SearchableDropDown
            state={selectedUserId}
            setState={(value) => {
              setSelectedUserId(value == "" ? null : value);
            }}
            name="userId"
            label=""
            items={userNameOptions}
            placeholder="Select a User Planner Email"
          />
        )}
      </Grid>
    </Grid>
  );

  const onCancel = () => {
    setSelectedUserId(null);
    closePopup();
  };

  const submit = () => {
    let LinkRequest = {
      plannerId: selectedPlannerId,
      userId: selectedUserId,
    };
    updateData(
      LINK_PLANNER_WITH_EMAIL,
      LinkRequest,
      "Planner linked to user successfully"
    )
      .then((response) => {
        if (response?.status === 200) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error("Error linking planner:", error);
      });
  };

  return (
    <GenericPopup
      icon={<NoteAddRoundedIcon color="white" fontSize="large" />}
      open={showPopup}
      title={"Link Planner With User Email"}
      content={content}
      buttons={
        isPopupLoading
          ? []
          : [
              {
                text: "Cancel",
                onClick: onCancel,
                color: "secondary",
                variant: "outlined",
              },
              {
                text: "Add",
                onClick: submit,
                color: "primary",
                variant: "contained",
                loading: linkPlannerLoading,
                disabled: !!plannerEmail || selectedUserId == null,
              },
            ]
      }
    />
  );
};
